export default "__VITE_ASSET__B$AiangZ__"